// extracted by mini-css-extract-plugin
module.exports = {"moveRight":"Mapping_moveRight_3-06I","moveLeft":"Mapping_moveLeft_KOZlO","dataTableCon":"Mapping_dataTableCon_8K2j6","headingBold":"Mapping_headingBold_12gqT"};